'use client';
import { solvedMillions } from '@puzzlio/core';
import { cn } from '@/app/lib/utils';
import { useUserLoading } from '@/app/providers/UserProvider';
import { QuotesSection } from '@/app/components/QuotesSection';
import { SubscriptionPromoSection } from '@/app/components/SubscriptionPromoSection';
import { HomePitch } from './HomePitch';
import { SolvedCounter } from './SolvedCounter';
import { ReadyToPlaySection } from './ReadyToPlaySection';

/*
  Everything under the game cards. A signed-in player already knows what we are, so they get only the
  subscribe pitch (and subscribers not even that); anyone else gets the full introduction. Nothing shows
  until we know which, so a returning player never sees the introduction flash past.
*/
export function HomeSections({ totalSolves }: { totalSolves: number | null }) {
  const [user, isLoading] = useUserLoading();
  if (isLoading) return null;

  // On a phone it butts against the last game card, as the bands do.
  if (user?.auth?.email) return <SubscriptionPromoSection className="md:mt-8" />;

  const millions = solvedMillions(totalSolves);
  const showSolves = millions !== null;

  return (
    <>
      <HomePitch className="mx-6 mt-10 md:mx-0 md:mt-7" />
      <div className={cn('mt-9 grid grid-cols-1 gap-12 md:mt-4 md:gap-4', showSolves && 'md:grid-cols-[8fr_7fr]')}>
        <QuotesSection className="mx-6 md:mx-0" />
        {millions && <SolvedCounter millions={millions} className="md:rounded-xl" />}
      </div>
      {/* On a phone the solved band butts against it; without that band, it needs room of its own. */}
      <SubscriptionPromoSection className={cn('md:mt-10', !showSolves && 'mt-12')} />
      <ReadyToPlaySection className="md:mt-4" />
    </>
  );
}
